import { CoordinatingGroup, ResponseStatus } from "@/api/dtos";
import { createContext } from "react"

export interface ICoordinatingGroupContext {
    data?: CoordinatingGroup;
    error?: ResponseStatus;
    loading: boolean;
    validating: boolean;
    refresh: () => Promise<CoordinatingGroup | undefined>
}

export const CoordinatingGroupContext = createContext<ICoordinatingGroupContext>({
    loading: false,
    validating: false,
    data: undefined,
    error: undefined,
    refresh: () => {
        return new Promise<CoordinatingGroup | undefined>(res => {
            res(undefined);
        });
    }
});

export default CoordinatingGroupContext;